// extracted by mini-css-extract-plugin
var _1 = "ReOxVuhsevpYfLJ4pu6y";
var _2 = "dark-mode";
var _3 = "RhCBCN4Ykl9oK8Jbk9Av";
export { _1 as "active", _2 as "dark-mode", _3 as "toggle" }
